export const saveScope = async (
  sendAndWaitWs,
  scopeId,
  scopeName,
  active = false
) => {
  const request = { scopeName, active };
  const response = await sendAndWaitWs(
    "/scope/save",
    JSON.stringify(request),
    scopeId
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const deleteScope = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/scope/delete",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const deleteScopeMembership = async (sendAndWaitWs, deleteEmail) => {
  const request = { deleteEmail };
  const response = await sendAndWaitWs(
    "/scope/membership/delete",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const exitScope = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/scope/membership/exit",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const switchScope = async (sendAndWaitWs, targetScopeId) => {
  const response = await sendAndWaitWs("/focus", targetScopeId);
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const inviteMember = async (sendAndWaitWs, inviteeEmails) => {
  const request = { inviteeEmails };
  const response = await sendAndWaitWs(
    "/scope/membership/invite",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const updateMember = async (
  sendAndWaitWs,
  targetScopeId,
  accept,
  active = false
) => {
  const request = { targetScopeId, accept, active };
  const response = await sendAndWaitWs(
    "/scope/membership/update",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getScopeInfo = async (sendAndWaitWs, scopeId) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/scope/get",
    JSON.stringify(request),
    scopeId
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listScopeInfo = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs("/scope/list", JSON.stringify(request));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listScopePreferences = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/scope/preference/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const saveScopePereference = async (sendAndWaitWs, sp) => {
  const response = await sendAndWaitWs(
    "/scope/preference/save",
    JSON.stringify(sp)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const saveScopeExecutionEnv = async (sendAndWaitWs, env) => {
  const request = { env };
  const response = await sendAndWaitWs(
    "/scope/env/update",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listInvitation = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/scope/invitation/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const cleanScopeData = async (sendAndWaitWs, dryRun = false) => {
  const request = { dryRun };
  const response = await sendAndWaitWs(
    "/scope/fixData",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const searchLocation = async (sendAndWaitWs, text) => {
  const request = { text };
  const response = await sendAndWaitWs(
    "/scope/location/search",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listLocations = async (sendAndWaitWs, scopeId = null) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/scope/location/list",
    JSON.stringify(request),
    scopeId
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const saveLocation = async (sendAndWaitWs, scopeId, location) => {
  const response = await sendAndWaitWs(
    "/scope/location/save",
    JSON.stringify(location),
    scopeId
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const deleteLocation = async (sendAndWaitWs, scopeId, location) => {
  const response = await sendAndWaitWs(
    "/scope/location/delete",
    JSON.stringify(location),
    scopeId
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
